import React from "react";
import clientOneImg1 from "../../assets/images/resources/client-one-img-1.png";
import clientOneImg2 from "../../assets/images/resources/client-one-img-2.png";
import clientOneImg3 from "../../assets/images/resources/client-one-img-3.png";
import clientOneImg4 from "../../assets/images/resources/client-one-img-4.png";
import clientOneImg5 from "../../assets/images/resources/client-one-img-5.png";
import clientOneImg6 from "../../assets/images/resources/client-one-img-6.png";
import clientOneImg7 from "../../assets/images/resources/client-one-img-7.png";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";

const settingsPartner = {
  autoplay: {
    delay: 1000,
  },
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesPerView: 3,
        arrows: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesPerView: 1,
      },
    },
    {
      breakpoint: 740,
      settings: {
        slidesPerView: 1,
        arrows: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesPerView: 1,
        arrows: false,
      },
    },
  ],
}

  function PartnerFive() {


    return (
      <div>
        <section className="partener-five">
          <div className="container-fluid">
            <div
              className="partener-five-title text-center wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <p>Ive 1253+ Global Clients &amp; lots of Project Complete</p>
            </div>
            <Swiper className="swiper-wrapper" {...settingsPartner} slidesPerView={7} spaceBetween={20} autoplay={true} autoplayspeed={10000}>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg1}
                    alt="client-one-img-1"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg2}
                    alt="client-one-img-2"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg3}
                    alt="client-one-img-3"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg4}
                    alt="client-one-img-4"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg5}
                    alt="client-one-img-5"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg6}
                    alt="client-one-img-6"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg7}
                    alt="client-one-img-7"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg1}
                    alt="client-one-img-1"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg2}
                    alt="client-one-img-2"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg3}
                    alt="client-one-img-3"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg4}
                    alt="client-one-img-4"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg5}
                    alt="client-one-img-5"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg6}
                    alt="client-one-img-6"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide className="partener-five-single">
                <div className="partener-five-img-box">
                  <img
                    src={clientOneImg7}
                    alt="client-one-img-7"
                  />
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </section>
      </div>
    );
}

export default PartnerFive;
